import { render, staticRenderFns } from "./DisplayDate.vue?vue&type=template&id=50209584&"
import script from "./DisplayDate.vue?vue&type=script&lang=js&"
export * from "./DisplayDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports